module.exports = __webpack_public_path__ + "assets/images/silver-31e123c055acd7a5936cfbe1f3044315.png";